import {customElement, property} from 'lit/decorators.js';
import {style} from './link.styles';
import {typo3Style} from './link--typo3.styles';
import {html, LitElement, nothing} from 'lit';
import {when} from 'lit/directives/when.js';

// eslint-disable-next-line
declare let _paq: any

@customElement('sbk-link')
export class SbkLink extends LitElement {

    @property({type: Boolean})
    disabled? = false;

    @property()
    icon? = ''

    @property({attribute: 'icon-position'})
    iconPosition?: 'left' | 'right' = 'left'

    @property({type: Boolean, attribute: 'is-bold'})
    isBold = false

    @property()
    href = '';

    @property()
    size?: '2xs' | 'xs' | 'sm' | 'md' | '' = '';

    @property()
    target?: '_blank' | '_parent' | '_self' | '_top' | '' = '';

    @property()
    variant?: 'icon-navigation' | 'reduced-navigation' | 'navigation' | 'regular' | 'underlined' = 'underlined';

    @property({type: Boolean, attribute: 'is-selected'})
    isSelected = false

    @property()
    hyphens: 'auto' | 'none' = 'auto';

    static get styles() {
        return [style, typo3Style];
    }

    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.trackMatomo)
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.trackMatomo)
    }

    render() {
        return html`
            <div class=${this.variant === 'navigation' ? 'link-wrapper__navigation' : 'link-wrapper'}>
                ${this.disabled ? this.renderDisabledAsText() : this.href ? this.renderLink() : this.renderButton()}
            </div>
        `;
    }

    private renderLink() {
        return html`
            <a part="link" class="link link-${this.variant}${this.isBold ? '-bold' : ''}${this.size ? `-${this.size}` : ''} ${this.isSelected ? 'link--selected' : ''} ${this.hyphens === 'none' ? 'link--noHyphens' : ''}"
               href=${this.href}
               title=${this.title || nothing}
               target=${this.target || nothing}
            >
                ${when(this.icon && this.iconPosition === "left", () => this.renderIcon())}
                <span class="link__text">
                    <slot></slot>
                </span>
                ${when(this.icon && this.iconPosition === "right", () => this.renderIcon())}
            </a>
        `;
    }

    private renderButton() {
        return html`
            <button class="link link-${this.variant}${this.isBold ? '-bold' : ''}${this.size ? `-${this.size}` : ''} ${this.isSelected ? 'link--selected' : ''} ${this.hyphens === 'none' ? 'link--noHyphens' : ''}">
                ${when(this.icon && this.iconPosition === "left", () => this.renderIcon())}
                <span class="link__text">
                    <slot></slot>
                </span>
                ${when(this.icon && this.iconPosition === "right", () => this.renderIcon())}
            </button>
        `;
    }

    private renderDisabledAsText() {
        return html`
            <p class="link link--disabled link-${this.variant}-${this.isBold ? 'bold-' : ''}${this.size} ${this.hyphens === 'none' ? 'link--noHyphens' : ''}">
                ${when(this.icon && this.iconPosition === "left", () => this.renderIcon())}
                <slot></slot>
                ${when(this.icon && this.iconPosition === "right", () => this.renderIcon())}
            </p>
        `;
    }

    private renderIcon() {
        return html`
            <sbk-icon size=${this.size === 'xs' || this.size === '2xs' ? 20 : 24} symbol=${this.icon}></sbk-icon>`
    }

    trackMatomo() {
        if (this.href.match(/@sbk.org$/) !== null) {
            _paq.push(['trackGoal', 12])
        }
    }
}
